import { Col, Form } from 'antd'
import useFetchSelectUrl from '../elements/Hooks/useFetchSelectUrl'
import InfoTooltip from '../elements/InfoTooltip'
import ViewDownload from '../elements/ViewDownload'
import _, { get, isEmpty } from 'lodash'
import Auth from '../modules/Authentication'
import { threeFormItemLayout } from '../modules/FormItems'
import React from 'react'
import { streamUrl } from '../variables'

const auth = new Auth()

function FileSelect(props) {
  const { doc, acc, docID, label, getFieldValue, getFieldDecorator, forceFetch = true } = props

  let file = (getFieldValue(acc) || get(doc, acc) || '').replace('files/', '')

  const owner = docID || doc._id

  const [FileSelectCmp] = useFetchSelectUrl(
    {
      name: `${owner}_files`,
      url: `files/?folder=${owner}`,
      cache: !forceFetch,
      forceFetch: forceFetch,
    },
    [owner],
    isEmpty(owner)
  )

  return (
    <Col span={12}>
      <Form.Item
        {...threeFormItemLayout}
        label={<InfoTooltip value={label} title={'If empty; please upload files in documents tab.'} />}>
        {getFieldDecorator(acc, {
          initialValue: get(doc, acc),
        })(<FileSelectCmp style={{ width: '80%' }} keyAtr="_id" valueAtr="name" placeholder={'label'} />)}
        &nbsp;
        <ViewDownload
          view={`${streamUrl}files/${file}?action=view&access_token=${auth.getAccessToken()}`}
          download={`${streamUrl}files/${file}?action=download&access_token=${auth.getAccessToken()}`}
          disabled={_.isEmpty(file)}
        />
      </Form.Item>
    </Col>
  )
}

export default FileSelect
